import { useEffect, useState } from "react";
import { useParams, Link } from "react-router-dom";
import { api, STATUS_LABELS } from "@/lib/api";
import { CheckCircle2, Copy } from "lucide-react";
import { toast } from "sonner";

export default function Confirmation() {
  const { bookingId } = useParams();
  const [booking, setBooking] = useState(null);
  useEffect(() => { api.get(`/bookings/${bookingId}`).then((r) => setBooking(r.data)); }, [bookingId]);

  if (!booking) return <div className="pt-24 text-center text-slate-500">Loading…</div>;

  const copy = () => {
    navigator.clipboard.writeText(booking.ticket_code);
    toast.success("Ticket code copied");
  };

  return (
    <div className="pt-24 pb-16 max-w-3xl mx-auto px-4 sm:px-6 lg:px-8" data-testid="confirmation-page">
      <div className="p-8 md:p-10 rounded-3xl border border-emerald-200 bg-gradient-to-br from-emerald-50 to-white">
        <CheckCircle2 className="w-10 h-10 text-emerald-600" />
        <div className="mt-4 overline">Step 6 of 6</div>
        <h1 className="mt-1 text-3xl md:text-4xl font-bold tracking-tight text-slate-900">
          You're all set, {booking.customer.name.split(" ")[0]}!
        </h1>
        <p className="mt-3 text-slate-600 leading-relaxed">
          Drop off your <strong>{booking.brand} {booking.model_name}</strong> on{" "}
          <strong>{booking.dropoff_date}</strong> at <strong>{booking.dropoff_time}</strong>.
          We've got your parts on order — labor is paid when you pick up.
        </p>
        <div className="mt-6 flex items-center gap-3 bg-white border border-slate-200 rounded-xl px-4 py-3 w-fit">
          <span className="text-xs text-slate-500 uppercase tracking-widest">Ticket</span>
          <span data-testid="confirmation-ticket-code" className="font-mono font-bold text-slate-900">{booking.ticket_code}</span>
          <button onClick={copy} className="p-1 hover:bg-slate-100 rounded" aria-label="Copy ticket"><Copy className="w-4 h-4 text-slate-500" /></button>
        </div>
      </div>

      <div className="grid md:grid-cols-2 gap-4 mt-6">
        <div className="p-6 rounded-2xl border border-slate-200 bg-white">
          <div className="overline mb-2">Current status</div>
          <div className="text-lg font-semibold text-slate-900">{STATUS_LABELS[booking.status] || booking.status}</div>
        </div>
        <div className="p-6 rounded-2xl border border-slate-200 bg-white">
          <div className="overline mb-2">Balance at pickup</div>
          <div className="font-mono text-2xl font-bold text-sky-900">${booking.quote.labor_total.toFixed(2)}</div>
          <div className="text-xs text-slate-500 mt-1">Cash or card in-store</div>
        </div>
      </div>

      <div className="mt-6 flex flex-wrap gap-3">
        <Link to="/track" className="px-5 py-2.5 rounded-xl bg-slate-900 text-white text-sm font-semibold hover:bg-slate-800">Track this repair</Link>
        <Link to="/" className="px-5 py-2.5 rounded-xl bg-white border border-slate-200 text-slate-900 text-sm font-semibold hover:border-slate-400">Back to home</Link>
      </div>
    </div>
  );
}
